const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function SvgIntTransbank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e722c011-9020-4132-8ffe-c6aba7f1d2c4",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".f3bbab96-1d10-45a9-9867-a4dc20f93973{fill:#e6e6e6;}.ff33c924-9c44-4df7-9344-169e1f6ea2cc{fill:#019ce1;}.bc79aa5e-6969-4b83-8e89-75bb7d22d40a{fill:#d9006c;}")), /*#__PURE__*/React.createElement("rect", {
    className: "f3bbab96-1d10-45a9-9867-a4dc20f93973",
    width: 52,
    height: 52,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "ff33c924-9c44-4df7-9344-169e1f6ea2cc",
    d: "M17.46,18.91c.09-.05.08-.14.1-.22a2.62,2.62,0,0,1,2.63-2.09,2.65,2.65,0,0,1,.3,5.28,2.61,2.61,0,0,1-2.93-2c0-.1,0-.21-.1-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bc79aa5e-6969-4b83-8e89-75bb7d22d40a",
    d: "M24.88,23.52v-13a.75.75,0,0,0,0-.15.77.77,0,0,1,.81-.84h2.66a.89.89,0,0,1,.55.16.73.73,0,0,1,.31.61v6.55c0,.3,0,.28.27.28h4.2a.79.79,0,0,1,.82.55.84.84,0,0,1,0,.27c0,.9,0,1.79,0,2.68a.83.83,0,0,1-.85.84c-1.4,0-2.8,0-4.2,0-.31,0-.28,0-.28.26V35.32a4.51,4.51,0,0,0,.15,1.27,2,2,0,0,0,1.76,1.51,5.92,5.92,0,0,0,.84,0c.59,0,1.18,0,1.77,0a.8.8,0,0,1,.81.79c0,.91,0,1.82,0,2.74a.77.77,0,0,1-.82.8c-.86,0-1.73,0-2.6,0a6.63,6.63,0,0,1-3.83-1.19A5.67,5.67,0,0,1,25.11,38a7.39,7.39,0,0,1-.23-1.88Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntTransbank);
export default __webpack_public_path__ + "static/media/Int_TRANSBANK.73d0234f3ab401ef844de4351283846c.svg";
export { ForwardRef as ReactComponent };